import {
  TICKET_LIST,
  EVENT_USER_CATEGORIES,
  MANGAE_TICKETS_COUNT,
  ASSIGNED_ATTENDEE_TICKETS,
  ASSIGNED_ATTENDEE_ERRORS,
  APPLIED_COUPON,
  APPLIED_COUPON_REMOVED,
  ORDER_DATA,
  OPENUSEREDIT_MODAL,
  ALLOW_CC_EMAILS,
  ASSIGN_FLOW,
} from "@ticketsaction";

export let ticketLists = (state = [], action) => {
  if (action.type === TICKET_LIST) {
    return action.payload;
  }
  return state;
};

export let eventUserCategories = (state = [], action) => {
  if (action.type === EVENT_USER_CATEGORIES) {
    return action.payload;
  }
  return state;
};

export let manageTicketsCount = (state = [], action) => {
  if (action.type === MANGAE_TICKETS_COUNT) {
    return action.payload;
  }
  return state;
};

export let assignedAttendeeTickets = (state = {}, action) => {
  if (action.type === ASSIGNED_ATTENDEE_TICKETS) {
    return action.payload;
  }
  return state;
};

export let assignedAttendeeErrors = (state = {}, action) => {
  if (action.type === ASSIGNED_ATTENDEE_ERRORS) {
    return action.payload;
  }
  return state;
};

export let promoApplied = (state = {}, action) => {
  if (action.type === APPLIED_COUPON) {
    return action.payload;
  }
  return state;
};

export let promoAppliedRemoved = (state = {}, action) => {
  if (action.type === APPLIED_COUPON_REMOVED) {
    return action.payload;
  }
  return state;
};

export let orderData = (state = {}, action) => {
  if (action.type === ORDER_DATA) {
    return action.payload;
  }
  return state;
};

export let isUserEditopen = (state = false, action) => {
  if (action.type === OPENUSEREDIT_MODAL) {
    return action.payload;
  }
  return state;
};
export let allowCCEmails = (state = { allow: false }, action) => {
  if (action.type === ALLOW_CC_EMAILS) {
    return action.payload;
  }
  return state;
};
export let assignflow = (state = "beforepayment", action) => {
  if (action.type === ASSIGN_FLOW) {
    return action.payload;
  }
  return state;
};
